import PropTypes from 'prop-types'

const navigationItemPropType = PropTypes.exact({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  analyticsEventName: PropTypes.string,
  /**
   * The destination the visitor is already on. It stays in the list (the
   * drawer is a section index, not a "go somewhere else" list) but is marked
   * aria-current and doesn't navigate.
   */
  current: PropTypes.bool,
})

/**
 * The level ABOVE the listed items — the drawer's top row ("All Categories").
 * Same shape as an item minus the id and the icon: the drawer supplies its
 * own glyph so every experience's up row reads the same.
 */
export const navigationParentPropType = PropTypes.exact({
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  analyticsEventName: PropTypes.string,
})

/**
 * The navigation an experience declares on ExperienceShell, threaded unchanged
 * through ExperienceChrome and ConditionalHeader to ExperienceNavControls. One
 * definition so the layers can't drift.
 */
export const experienceNavPropTypes = {
  /** The experience's own front door, for Home. */
  navHomePath: PropTypes.string,
  /** Analytics prefix for the kids-return action: fires `<prefix>:CLOSE_ACTIVITY:CLICK`. */
  navAnalyticsPrefix: PropTypes.string,
  /** The card's section index: this level's destinations, the current one included. */
  navItems: PropTypes.arrayOf(navigationItemPropType),
  /** Names the level `navItems` belong to - the card's section heading. */
  navSectionLabel: PropTypes.string,
  /** The level above `navItems` - the card's top row. */
  navParent: navigationParentPropType,
  /**
   * Whether the stepper (the `< >` pill that walks `navItems` without opening
   * the card) may render. Defaults to true; an experience sets it false when
   * its design has no room for a second floating control (DSC-10671). The card
   * and its handle are unaffected - the same destinations stay one tap away.
   */
  navShowStepButtons: PropTypes.bool,
}

export default navigationItemPropType
